module.exports = __webpack_public_path__ + "img/pdf.bf27fca1.svg";